import { FC } from 'react';

import { CourseInstructor } from '../CourseInstructor/CourseInstructor';
import { CourseAims } from '../CourseAims/CourseAims';
import { CourseLessons } from '../CourseLessons/CourseLessons';
import { Video } from '@new/common/ui/Video/Video';
import { type CourseWithProgress } from '@teachur/http-client';

interface CourseDetailsTabProps {
  course: CourseWithProgress;
}

export const CourseDetailsTab: FC<CourseDetailsTabProps> = ({ course }) => {
  const hasVideo = !!course.introVideo;
  const hasGoals = !!course.goals?.length;

  const instructorContent = course.mainInstructor && (
    <CourseInstructor
      instructor={course.mainInstructor}
      courseCode={course.code || 'N/A'}
      creditHours={course.credit || 0}
    />
  );

  const aimsContent = hasGoals && <CourseAims goals={course.goals!} />;

  return (
    <div className="flex flex-col gap-6">
      {hasVideo ? (
        <div className="flex flex-col lg:flex-row items-start justify-between gap-6 lg:gap-8">
          <div className="flex min-w-0 flex-1 flex-col gap-6 lg:gap-8 max-h-150 overflow-y-auto">
            {aimsContent}
          </div>

          <div className="flex min-w-0 lg:min-w-100 lg:max-w-140 flex-[0_1_40%] flex-col gap-6 lg:gap-8 w-full lg:w-auto">
            <Video videoUrl={course.introVideo!} />
            {instructorContent}
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-6 lg:gap-8">
          {instructorContent}
          <div className="max-h-150 overflow-y-auto">{aimsContent}</div>
        </div>
      )}

      <CourseLessons courseId={course.id} courseStatus={course.status} isPaused={course.isPaused} />
    </div>
  );
};
